/**
 * Маршруты админки.
 *
 * Пока не загрузился профиль — экран пустой, а не «вход»: иначе при каждом
 * обновлении страницы сотрудник видел бы форму входа на долю секунды.
 */
import { Navigate, Route, Routes } from 'react-router-dom';

import { AuditScreen } from './screens/Audit';
import { BrandsScreen } from './screens/Brands';
import { CompanyRequestsScreen } from './screens/CompanyRequests';
import { CampaignsScreen } from './screens/Campaigns';
import { ContestsScreen } from './screens/Contests';
import { LoginScreen } from './screens/Login';
import { OverviewScreen } from './screens/Overview';
import { ReviewsScreen } from './screens/Reviews';
import { SettingsScreen } from './screens/Settings';
import { SlidesScreen } from './screens/Slides';
import { SpheresScreen } from './screens/Spheres';
import { StaffScreen } from './screens/Staff';
import { VisitsScreen } from './screens/Visits';
import { useAdmin } from './session';

export function App() {
  const { signedIn, loading } = useAdmin();

  if (loading) return <div className="boot" />;
  if (!signedIn) {
    return (
      <Routes>
        <Route path="/login" element={<LoginScreen />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<OverviewScreen />} />
      <Route path="/brands" element={<BrandsScreen />} />
      <Route path="/company-requests" element={<CompanyRequestsScreen />} />
      <Route path="/campaigns" element={<CampaignsScreen />} />
      <Route path="/contests" element={<ContestsScreen />} />
      <Route path="/reviews" element={<ReviewsScreen />} />
      <Route path="/slides" element={<SlidesScreen />} />
      <Route path="/spheres" element={<SpheresScreen />} />
      <Route path="/staff" element={<StaffScreen />} />
      <Route path="/visits" element={<VisitsScreen />} />
      <Route path="/settings" element={<SettingsScreen />} />
      <Route path="/audit" element={<AuditScreen />} />
      <Route path="/login" element={<Navigate to="/" replace />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
